import {defineMessages} from 'react-intl'

export const dealFreezeOfferBoxMessages = defineMessages({
  title: {
    id: 'dealFreeze.educationBannerTitleV2',
    defaultMessage: 'Not ready to book?'
  },
  freezableDeal: {
    id: 'dealFreeze.roomBannerFreezableDeal',
    defaultMessage: 'Freezable deal'
  },
  freezableDeals: {
    id: 'dealFreeze.offerBoxBannerFreezableDeals',
    defaultMessage: 'Freezable deals'
  },
  description: {
    id: 'dealFreeze.offerBoxDescription',
    defaultMessage: "We'll guarantee the room and price while you decide."
  },
  filterTooltip: {
    id: 'dealFreeze.offerBoxFilterTooltip',
    defaultMessage: 'Showing deals you can freeze while you decide.'
  },
  from: {
    id: 'from',
    defaultMessage: 'From'
  },
  viewDeals: {
    id: 'viewDeals',
    defaultMessage: 'View deals'
  }
})
